import React, { useEffect, useRef, useState } from 'react';

import './card.expand.scss';

interface ExpandCardProp {
    step: number;
    title: string;
    color: 'green'|'yellow' | 'orange' | 'violet' | 'purple' | 'red';
    initExpanded?: boolean;
    onExpand?:(e:boolean) => void;
    children: React.ReactNode;
}

const ExpandCard: React.FC<ExpandCardProp> = ({ children, step, title, color, initExpanded, onExpand }) => {
    const ref = useRef<HTMLDivElement>(null);
    const [expanded, setExpanded] = useState(!!initExpanded);
    const [heightExtend, setHeightExtend] = useState<number>(0);

    useEffect(() => {
        if (ref?.current) {
            setHeightExtend(ref.current.getBoundingClientRect().height);
        }
    }, [])


    const toggleExpand = () => {
        if(onExpand){
            onExpand(!expanded);
        }
        setExpanded(!expanded)
    }

    return (
        <div className={`_expandCard ${color}`}>
            <div className="_title" onClick={toggleExpand}>
                <div className="_numberStep">
                    <span>
                        {step}
                    </span>
                </div>
                <h3>
                    {title}
                </h3>
            </div>
            <div className="_explainContainer" style={{height: expanded ? `${heightExtend}px` : `0px`}}>
                <div className="_explain" ref={ref}>
                    {children}
                </div>
            </div>
        </div>
    )
}



export default ExpandCard;